export type PembatalanStatus = "draft" | "diajukan" | "disetujui" | "ditolak";

export interface KantongTersedia {
  id: number;
  kode_kantong: string;
  komponen: string | null;
  komponen_lain: string | null;
  label_komponen: string | null;
  gol_darah: string | null;
  rhesus: string | null;
  label_golongan: string | null;
  hasil_id: number;
  hasil_nomor: string | null;
  hasil_jenis: string;
}

export interface PembatalanKantong {
  id: number;
  hasil_pemeriksaan_darah_kantong_id: number;
  kode_kantong: string | null;
  komponen: string | null;
  label_komponen: string | null;
  gol_darah: string | null;
  rhesus: string | null;
  label_golongan: string | null;
}

export interface PembatalanKomponenDarah {
  id: number;
  register_id: string;
  pasien_rm: string;
  pasien_nama: string | null;
  unit_id: string | null;
  unit_nama: string | null;
  ruang: string | null;
  dibatalkan_at: string | null;
  alasan: string;
  status: PembatalanStatus;
  status_label: string;
  pemohon_user_id: number | null;
  pemohon_nama: string | null;
  signed_pemohon_at: string | null;
  diputus_nama: string | null;
  diputus_at: string | null;
  alasan_tolak: string | null;
  creator_user_id: number | null;
  jumlah_kantong: number;
  kantong: PembatalanKantong[];
  created_at: string | null;
}

export interface PembatalanForm {
  id: number | null;
  dibatalkan_at: string | null;
  alasan: string | null;
  ruang: string | null;
  kantong_ids: number[];
}

export interface PembatalanFilter {
  tgl_start: string | null;
  tgl_end: string | null;
  unit_id: string | null;
  status: PembatalanStatus | "" | null;
  term: string | null;
}

export const STATUS_PEMBATALAN_WARNA: Record<PembatalanStatus, string> = {
  draft: "orange",
  diajukan: "blue",
  disetujui: "green",
  ditolak: "grey"
};

export const ALASAN_PEMBATALAN_OPSI = [
  "Pasien pulang",
  "Pasien meninggal",
  "Tidak jadi transfusi"
];
